var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dribbble-Light-Preview"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "profile_round-_1342_",
    "data-name": "profile_round-[#1342]",
    className: "cls-1",
    d: "M662.5,720h-525c-28.26,0-49.12-27.88-38.47-53.52C148.51,547.92,264.68,480,400,480s251.53,67.92,301,186.48C711.62,692.12,690.76,720,662.5,720M236.67,240C236.67,151.76,310,80,400,80s163.33,71.76,163.33,160S490.07,400,400,400,236.67,328.24,236.67,240M798.23,705.44C768.54,571.08,675.69,471.92,553.48,426.92,618.24,375.84,656,293.24,642.13,202.8,626,97.88,536.94,13.92,429.39,1.68,280.93-15.24,155,98,155,240c0,75.6,35.77,143,91.55,186.92C124.3,471.92,31.49,571.08,1.76,705.44-9,754.28,31.16,800,82.16,800H717.83c51,0,91.22-45.72,80.4-94.56"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.1e9188a78a3d70db877674dc3bfa2ad9.svg";
export { ForwardRef as ReactComponent };